import React from "react";
import Link from "next/link";

import { Article } from "custom-types/Wordpress";

import NewsArticleDate from "components/news/NewsArticleDate";

const AuthorHeader: React.FC<{
  article: Article;
}> = ({ article }) => {
  const { author, date, modified } = article;
  return (
    <div data-testid="author-header" className="flex flex-col">
      <Link className="font-bold text-sm" href={author.urlPath} rel="author">
        {author.name}
      </Link>
      <NewsArticleDate date={date} modified={modified} />
    </div>
  );
};

export default AuthorHeader;
